import React, {useContext, useState} from 'react';
import FloContext from "../contexts/floContext";
import InstructionOptions from "../options/instructionOptions";
import ContentEditor from "../editor/editor";

export default function Instructions() {
   const [isEdit, setIsEdit] = useState({_id: null});
   const {steps, onNewInstruction}: any = useContext(FloContext);

   function onFocus(step: any) {
      setIsEdit(step);
   }

   return (
       <div className="instructions flex hr-right">
          <div className="instruction-content">
             <div className="font-26 rubik-medium margin-b-10">Create interactions and animations</div>
             <div className="light-color font-15 margin-b-20">
                Created by <span className="rubik-medium">Abhishek Sharma</span>
             </div>
             <div className="font-15 grey-color line-22 margin-b-30">
                With prototyping in Figma, you can create multiple flows for your prototype in one page to
                preview a user's full journey and experience through your designs.
             </div>

             <ul className="instruction-list grey-color font-15">
                {
                   steps.map((step: any, index: number) => {
                      return (
                          <li key={index} className={'options-box ' +  (isEdit._id === step._id ? 'editing' : '')}>
                             <div className={'content '}>
                                <div className="instruction-head flex align-top hr-space-between">
                                   <div className="index">{index + 1}</div>
                                   <div className="instruction">
                                      <div className="instruction-editor">
                                         <ContentEditor step={step} onFocus={onFocus} />
                                      </div>
                                      <InstructionOptions step={step} />
                                   </div>
                                </div>
                                {
                                    step.image === 'screen-1.png' &&
                                    (<div className="screen icon">
                                       <img src={require('../../assets/images/screen-1.png')} alt=""/>
                                    </div>)
                                }
                                {
                                    step.image === 'screen-2.png' &&
                                    (<div className="screen icon">
                                       <img src={require('../../assets/images/screen-2.png')} alt=""/>
                                    </div>)
                                }
                             </div>
                             <div className="add-new">
                                <div className="add-new-btn" onClick={() => onNewInstruction(step)}>Add new</div>
                             </div>
                          </li>
                      )
                   })
                }

             </ul>
          </div>
       </div>
   )
}
